export function reselectSelected() {
  try {
    // @ts-ignore
    const containerRef = window.containerRef;
    const win: any = containerRef?.current?.contentWindow;
    if (!win || !win.RoutingScriptMdel) return;

    const root = win.RoutingScriptMdel.getRootEntity?.();
    const sceneController = root?.script?.sceneController;
    const current = sceneController?.selectedEntity;
    if (!sceneController || !current) return;

    // Deselect like clicking on floor
    if (typeof sceneController.onSelectionChanged === "function") {
      sceneController.onSelectionChanged(null);
      // Reselect on next microtask/frame
      setTimeout(() => {
        try {
          sceneController.onSelectionChanged(current);
        } catch {}
      }, 0);
    }
  } catch {}
}

